// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".leftReview[data-v-42c123b3] {\n  width: 369px;\n  min-width: 369px;\n  height: auto;\n}\n", ""]);
// Exports
module.exports = exports;
